class ModelViewController {
  constructor() {
  }
}

export default ModelViewController;



// WEBPACK FOOTER //
// ./client/app/common/model-view/model-view.controller.js